import React from "react";
import { Button, Table } from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";
import { sharedServices } from "../../../APIServices/PasswordManagement/sharedServices";
import { useEffect } from "react";
import { useState } from "react";
import Swal from "sweetalert2";
import Moment from "react-moment";

const ShareWithGroup = ({auth, itemData, Show}) => {
  const [sharedList, setSharedList] = useState([]);
  const [loader, setLoader] = useState(false);
  const getSharedItemGroupList = async () => {
    setLoader(true);
    let data = await sharedServices.getSharedItemGroupList(auth, itemData?.itemId);
    setSharedList(data?.data || []);
    setLoader(false);
  };

  const revokedSharedItemGroup = async (itemId, sharedId, sharedWith, id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to revoked this shared item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, revoked it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const userData = {
          itemId: itemId,
          sharedId: sharedId,
          sharedWith: sharedWith,
          id: id,
        };
        const data = await sharedServices.revokedSharedItemGroup(auth, userData);
        if (data?.statusCode === 200) {
          getSharedItemGroupList();
        }
      }
    });
  };

  const deleteSharedItemGroup = async (itemId, sharedId, sharedWith, id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete share history?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const userData = {
          itemId: itemId,
          sharedId: sharedId,
          sharedWith: sharedWith,
          id: id,
        };
        const data = await sharedServices.deleteSharedItemGroup(auth, userData);
        if (data?.statusCode === 200) {
          getSharedItemGroupList();
        }
      }
    });
  };

  function isExpired(expiryAt) {
    if (!expiryAt) {
      return false;
    }
    const now = new Date();
    return now > new Date(expiryAt);
  }

  useEffect(() => {
    if (itemData && Show) {
      getSharedItemGroupList();
    }
  }, [auth, itemData, Show]);
  return (
    <>
      <Table hover className="m-0" style={{ verticalAlign: "middle" }}>
        <thead className="position-sticky top-0">
          <tr>
            <th className="CP" style={{ fontSize: 13 }}>
              Shared With Group
            </th>
            <th className="CP" style={{ fontSize: 13 }}>
              Expiries
            </th>
            <th className="CP text-center" style={{ fontSize: 13 }}>
              Status
            </th>
            <th className="CP text-center" style={{ fontSize: 13 }}>
              Revoke
            </th>
            <th className="CP text-center" style={{ fontSize: 13 }}>
              Delete
            </th>
          </tr>
        </thead>
        <tbody>
          {sharedList?.map((item, index) => (
            <tr key={index}>
              <td className="item-secondary">
                <div className="item-title mb-1">{item?.sharedGroupName}</div>
                <Moment title="Shared Date | Time" format="DD MMM YYYY | HH:mm">
                  {item?.sharedAt}
                </Moment>
              </td>
              <td className="item-secondary">
                <Moment format="DD MMM YYYY | HH:mm" withTitle>
                  {item?.expiryAt}
                </Moment>
              </td>
              <td
                className={`CP item-secondary text-center text-capitalize fw-bold ${
                  (item?.isRevoked || isExpired(item?.expiryAt)) ? "text-danger" : "text-success"
                }`}
              >
                {item?.isRevoked ? "Revoked" : isExpired(item?.expiryAt) ? "Expired" : "Shared"}
              </td>
              <td
                onClick={() => {
                  if (!(item?.isRevoked || isExpired(item?.expiryAt))) {
                    revokedSharedItemGroup(
                      item?.itemId,
                      item?.sharedId,
                      item?.sharedWith,
                      item?.id
                    );
                  }
                }}
                className="item-secondary text-center"
                title={
                  item?.isRevoked &&
                  `Revoked By: ${item?.revokedByName}\nRevoked DT: ${item?.revokedAt}`
                }
              >
                <Button
                  variant={
                    (item?.isRevoked || isExpired(item?.expiryAt))
                      ? "outline-secondary"
                      : "outline-primary"
                  }
                  disabled={(item?.isRevoked || isExpired(item?.expiryAt))}
                  className={!(item?.isRevoked || isExpired(item?.expiryAt)) && "fw-bold"}
                  style={{ fontSize: 11, padding: "1px 4px", borderRadius: 3 }}
                >
                  {item?.isRevoked ? "Revoked" : "Revoke Now"}
                </Button>
              </td>
              <td
                onClick={() => {
                  if (item?.isRevoked || isExpired(item?.expiryAt)) {
                    deleteSharedItemGroup(
                      item?.itemId,
                      item?.sharedId,
                      item?.sharedWith,
                      item?.id
                    );
                  }
                }}
                className="item-secondary text-center CP"
                title="Delete Share History"
              >
                <FaTrashAlt
                  className={
                    (item?.isRevoked || isExpired(item?.expiryAt))
                      ? "text-danger"
                      : "text-secondary"
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default ShareWithGroup;
